module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/casestudy-img-04-4588fb138a3978a2deed90bbf2a92517.png";